import { render, staticRenderFns } from "./aiOCR_recognition.vue?vue&type=template&id=ac0e1314&scoped=true"
import script from "./aiOCR_recognition.vue?vue&type=script&lang=js"
export * from "./aiOCR_recognition.vue?vue&type=script&lang=js"
import style0 from "./aiOCR_recognition.vue?vue&type=style&index=0&id=ac0e1314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0e1314",
  null
  
)

export default component.exports